
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { formRules } from "@/utils/formRules";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: { SimpleDialog },
})
export default class EditNonTransferable extends Vue {

  @Prop({ default: null })
  private initNonTransferableData: any;

  @Prop({ default: false })
  private showDialog: boolean;

  @Getter private isAdmin: boolean;
  @Getter private isMobile: boolean;

  private nonTransferableId: number = null;
  private originalNonTransferableDataStringify: string = "";
  private nonTransferableData: any = {
    name: "",
  };
  private valid: boolean = true;
  private loading: boolean = false;
  private rules = formRules;

  @Watch("initNonTransferableData", { immediate: true, deep: true })
  public handlerNonTransferableData(newVal): void {
    if (newVal?.id) {
      const { id, name } = newVal;
      this.nonTransferableId = id;
      this.nonTransferableData = { name };
      this.originalNonTransferableDataStringify = JSON.stringify(this.nonTransferableData);
    }
  }

  get isModified(): boolean {
    return JSON.stringify(this.nonTransferableData) !== this.originalNonTransferableDataStringify;
  }

  get canSubmit(): boolean {
    return this.valid && this.isModified;
  }

  private async editNonTransferable(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("nonTransferables/updateById", {
      id: this.nonTransferableId,
      data: this.nonTransferableData,
    }).then(() => {
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$t("actions.saved"),
      });
      this.$emit("success");
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loading = false;
    });
  }

  private async deleteNonTransferable(): Promise<void> {
    if (window.confirm("" + this.$t("NonTransferable.confirmDelete"))) {
      this.loading = true;
      await this.$store.dispatch("nonTransferables/deleteById", {
        id: this.nonTransferableId,
      }).then(() => {
        this.$store.commit("alerts/displaySuccess", {
          msg: this.$t("actions.deleted"),
        });
        this.$emit("deleted");
      }).catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
